import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const easeOut = [0.23, 1, 0.32, 1] as const;
const heroHighlights = ['6 Complete Volumes', '150 Ready-to-Coach Sessions', '5 Free Bonuses', 'Immediate Access'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-white border-b border-zinc-200" data-id="element-130" data-mp="128yysajftrxl">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-131" data-mp="xb5rtfab8tw9">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOut
      }} className="w-full" data-id="element-132" data-mp="s9zx5bx3awk3">
          <div className="inline-block px-3 py-1 rounded-full bg-violet-950 text-white font-display font-extrabold text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-2 sm:mb-3" data-id="element-133" data-mp="3d2bj5ngruvuh">
            MMA COACH READY
          </div>
          <p className="font-display font-bold text-violet-900 text-[11px] sm:text-sm tracking-wide uppercase mb-4 sm:mb-6" data-id="element-134" data-mp="3j6fw9kdl53b7">
            The complete visual MMA coaching system
          </p>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-black uppercase leading-tight mb-4 sm:mb-6 text-zinc-950" data-id="element-135" data-mp="39cflb1vmh3uk">
            Solve months of MMA session planning in just{' '}
            <span className="text-violet-600" data-id="element-136" data-mp="30gq1uydqijjt">5 minutes</span>
          </h1>

          <p className="text-sm sm:text-base md:text-lg text-zinc-600 max-w-3xl mx-auto mb-4 sm:mb-6" data-id="element-137" data-mp="359j8xswoe3z2">
            <span className="text-violet-700 font-semibold" data-id="element-138" data-mp="2qlep2llvzmep">150 Ready-to-Coach MMA Sessions</span> • 6
            Complete Volumes •{' '}
            <span className="text-violet-700 font-semibold" data-id="element-139" data-mp="2hj5exwuj5v1u">5 Professional Bonus Guides</span>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: easeOut
      }} className="relative w-full max-w-[320px] sm:max-w-lg md:max-w-3xl mb-4 sm:mb-6" data-id="element-140" data-mp="2lla8ywow4tp0">
          <img src={HERO_IMAGE} alt="MMA Coach Ready complete system: 6 volumes, 150 ready-to-coach sessions, Class Finder tablet and 5 bonus guides" className="relative z-10 w-full h-auto drop-shadow-xl" data-id="element-141" data-mp="ibyqgeyd5638" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: easeOut
      }} className="w-full" data-id="element-142" data-mp="1ayt6mzo5djaw">
          <p className="text-sm sm:text-lg md:text-xl text-zinc-700 leading-snug max-w-2xl mx-auto mb-3 sm:mb-4" data-id="element-143" data-mp="114kg2hiog0fd">
            A complete 6-in-1 visual coaching system created for MMA coaches who want structured,
            ready-to-use sessions without spending hours planning every week.
          </p>
          <p className="text-sm sm:text-lg md:text-xl text-zinc-950 font-semibold leading-snug max-w-2xl mx-auto mb-4 sm:mb-5" data-id="element-144" data-mp="1x9b590wn91ck">
            Open the system. Choose the skill. Follow the visual progression. Start coaching.
          </p>
          <p className="font-display font-extrabold text-violet-900 text-xs sm:text-sm tracking-wide uppercase mb-5 sm:mb-7" data-id="element-145" data-mp="268y71ntac965">
            100% Visual • Ready to open &amp; coach
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-146" data-mp="2g0lpx0bs0hw0">
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10" data-id="element-147" data-mp="2g25c17k45n5p">
              Get MMA Coach Ready Now
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-zinc-600" data-id="element-148" data-mp="2tz1zcz10wmhu">
            {heroHighlights.map(highlight => <div key={highlight} className="flex items-center gap-1.5" data-id="element-149" data-mp="zl104d1k9xh8">
                <CheckCircle size={14} className="text-green-600" aria-hidden="true" data-id="element-150" data-mp="4bdydk9ughqq" />
                <span data-id="element-151" data-mp="4d76z540pc1d">{highlight}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}